:host {
  height: auto;
}

.box-info::part(container) {
  padding: unset;
  width: 870px;
}

gz-info-box {
  padding: calc(2 * var(--spacer)) 0 0;
  line-height: 18px;
  --info-box-max-width: 870px;
}

.form-field-input {
  width: var(--form-field-label-width);
  margin-top: calc(var(--spacer) * 1.5);
}

.sub-module {
  width: 220px;
  margin-left: 30px;
}

.module-subtitle {
  color: var(--chart-300-icon-buttons);
}

.form-subtitle-info {
  margin-top: calc(var(--spacer) * 2.5);
  color: var(--chart-300-icon-buttons);
}

.form-section {
  margin-top: calc(var(--spacer) * 2.5);

  .flex-group {
    display: flex;
    align-items: flex-start;

    .module-icon {
      margin-top: 12px;
      width: 39px;
      color: var(--chart-302-icon-buttons-titles);
    }

    .module-info {
      margin-left: 39px;
      text-decoration: underline var(--blue-layout-400-primary);
    }

    .module-info:hover {
      text-decoration: none;
    }
  }

  .section-margin {
    width: var(--form-field-max-width, 490px);
    border-bottom: 1px solid var(--chart-101-pressed-dividers);
    padding-bottom: 7px;
  }
}
